// Merge event metadata (events.js) with localized text (eventTranslations.js).
import { EVENTS, EVENT_BY_SLUG } from "./events";
import { EVENT_I18N } from "./eventTranslations";

export function locEvent(slug, lang) {
  const meta = EVENT_BY_SLUG[slug] || {};
  const langs = EVENT_I18N[slug] || {};
  const tr = langs[lang] || langs.de || {};
  return { slug, ...meta, ...tr };
}

export function allEvents(lang) {
  return EVENTS.map((e) => locEvent(e.slug, lang));
}

// evUI re-exported from the lightweight eventUi module (no heavy EVENT_I18N pull).
export { evUI } from "./eventUi";
